
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6a3aac2e\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader!../../../vue-loader/lib/selector?type=styles&index=0!./iconButton.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./iconButton.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6a3aac2e\"}!../../../vue-loader/lib/selector?type=template&index=0!./iconButton.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/iconButton/iconButton.vue
// module id = 364
// module chunks = 1